import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { DefaultErrorBoundaryFallback } from 'shared/components/error-handling/DefaultErrorBoundaryFallback';

type Props = {
    children: ReactNode;
    reactPlugin: ReactPlugin;
};

export const DefaultErrorBoundary = ({ children, reactPlugin }: Props) => {
    const location = useLocation();

    const handleError = (error: unknown, errorInfo: ErrorInfo) => {
        const exception = error instanceof Error ? error : new Error(String(error));

        reactPlugin &&
            reactPlugin?.trackException({
                error: exception,
                exception,
                severityLevel: SeverityLevel.Error,
                properties: errorInfo
            });
    };

    return (
        <ErrorBoundary key={location.pathname} FallbackComponent={DefaultErrorBoundaryFallback} onError={handleError}>
            {children}
        </ErrorBoundary>
    );
};
